import { LayoutAnimationsValues, withTiming } from 'react-native-reanimated';

import { isIos, isWeb } from '@/utils/constants-platform-specific';

// this custom layout transition function is used to animate the layout changes,
// to ensure that all width and height changes and positions changes are animated smoothly
const smoothLayoutTransition = (values: LayoutAnimationsValues) => {
    'worklet';
    return {
        animations: {
            width: withTiming(values.targetWidth, { duration: 100 }),
            height: withTiming(values.targetHeight, { duration: 100 }),
            originX: withTiming(values.targetOriginX, { duration: 100 }),
            originY: withTiming(values.targetOriginY, { duration: 100 }),
        },

        initialValues: {
            width: values.currentWidth,
            height: values.currentHeight,
            originX: values.currentOriginX,
            originY: values.currentOriginY,
        },
    };
};

type AnimationFunction = () => {
    initialValues: Record<string, any>;
    animations: Record<string, any>;
};

export const getLayoutAnimationsTransition = () => {
    return isWeb ? undefined : smoothLayoutTransition;
};

export const getEnteringAnimation = (fn: AnimationFunction, hasRendered: boolean) => {
    return hasRendered && isIos ? fn : undefined;
};

export const getExitingAnimation = (fn: AnimationFunction) => {
    return isIos ? fn : undefined;
};
